export default __webpack_public_path__ + "static/media/photo--sm--rob.ccda3112.jpg";